var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"help-fun"},[_vm._l((_vm.classes),function(clazz){return _c('FunItem',{key:clazz.id,attrs:{"clazz":clazz}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }